
/**
 * Sets whether Focus Mode is enabled for the meeting.
 *
 * {
 *     type: SET_FOCUS_MODE_ENABLED,
 *     enabled: boolean
 * }
 */
export const SET_FOCUS_MODE_ENABLED = 'SET_FOCUS_MODE_ENABLED';
